export default function settings() {
    return window.SETTINGS;
}
